import React,{useEffect} from 'react';
import '../Assets/Additionalcss/Sacss.css'
import Salogo from '../Assets/Images/salogo.gif'

function Sanavbar({ openSidebar}) {

    useEffect(()=>{

        document.getElementById("san").innerHTML=localStorage.getItem('username')
    
         document.getElementById("sar").innerHTML=localStorage.getItem('RoleName')
    });
    return (
        <div className='SA-navbar'>
        <div className='SA-nav-icon'>
            <i className='fa fa-bars' onClick={openSidebar}></i>
        </div>

        <div className='SA-navbar-left'>
        <div className='SA-sidebar-img'>
             <img src={Salogo} alt="logo"/>&nbsp;&nbsp;
          
        </div>
           
        </div>

        <div className='SA-navbar-right'>
           <a>
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            </a>
            <div className='SA-right-navbar'>
            <span id='san'> </span>
            (<span id='sar'></span>)
            </div>
             
          

        </div>
    </div>
    );
}

export default Sanavbar;